import { SET_KONFIGURASI_MENU } from "../../../constants/types";

const initialState = {
  konfigurasiMenu: null,
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_KONFIGURASI_MENU:
      return {
        ...state,
        konfigurasiMenu: payload,
      };
    default:
      return state;
  }
}
